"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteBucketTaggingOutput = {
    type: "structure",
    required: [],
    members: {}
};
//# sourceMappingURL=DeleteBucketTaggingOutput.js.map